import React from 'react';

export default function AllowedFields({ allowed, children }) {
  if(!allowed) return null;
  
  return children;
}
